import { useQuery } from "@tanstack/react-query";
import { useParams, Link } from "react-router-dom";
import { fetchEmployeeProgram, fetchMyProgram } from "@/api/program";
import { useLang } from "@/i18n/LanguageContext";
import { ProgramView } from "./ProgramView";

/** The logged-in employee's own program. */
export function ProgramPage() {
  const { t } = useLang();
  const q = useQuery({ queryKey: ["my-program"], queryFn: ({ signal }) => fetchMyProgram(signal) });

  if (q.isLoading) return <div className="wrap" style={{ padding: 40 }}>{t("Laden…", "Loading…")}</div>;
  if (q.isError || !q.data) return <div className="wrap" style={{ padding: 40 }}>{t("Programma kon niet worden geladen.", "Could not load your program.")}</div>;

  return (
    <section>
      <div className="wrap">
        <div className="section-head">
          <p className="eyebrow">{t("Mijn onboarding", "My onboarding")}</p>
          <h2>{t("Welkom", "Welcome")}, {q.data.full_name}</h2>
          {q.data.start_date && <p>{t("Startdatum", "Start date")}: {new Date(q.data.start_date).toLocaleDateString()}</p>}
        </div>
        <ProgramView program={q.data} />
      </div>
    </section>
  );
}

/** Manager/org-admin preview of a specific employee's program. */
export function EmployeeProgramPage() {
  const { t } = useLang();
  const { id = "" } = useParams();
  const q = useQuery({ queryKey: ["emp-program", id], queryFn: ({ signal }) => fetchEmployeeProgram(id, signal) });

  if (q.isLoading) return <div className="wrap" style={{ padding: 40 }}>{t("Laden…", "Loading…")}</div>;
  if (q.isError || !q.data) return <div className="wrap" style={{ padding: 40 }}>{t("Programma kon niet worden geladen.", "Could not load this program.")}</div>;

  return (
    <section>
      <div className="wrap">
        <div className="section-head">
          <Link to="/app" className="eyebrow" style={{ marginBottom: 6 }}>← Dashboard</Link>
          <h2>{t("Traject van", "Journey of")} {q.data.full_name}</h2>
          <p style={{ color: "var(--grey-text)" }}>{t("Voorbeeldweergave zoals de medewerker het ziet", "Preview as the employee sees it")} ({q.data.progress.percent}%).</p>
        </div>
        <ProgramView program={q.data} readOnly />
      </div>
    </section>
  );
}
